import { Paper } from "@mui/material";
import Kanban from './DndKitMui/Kanban';
// import { useDefaultSensors } from './DndKitMui/presets';
import Sortable from './DndKitMui/Sortable';
import { iKanbanBoard, iKanbanItem, iTreeItem } from './DndKitMui/types';
import Tree from "./DndKitMui/Tree";

const SampleBoards: Array<iKanbanBoard> = [
  { id: 1, title: 'Init' },
  { id: 2, title: 'In Progress' },
  { id: 3, title: 'Done' },
]

const SampleKanbanItems: Array<iKanbanItem> = [
  { id: 1, title: '1 Init', board_id: 1 },
  { id: 2, title: '1 In Progress', board_id: 2 },
  { id: 3, title: '1 Done', board_id: 3 },
  { id: 4, title: '2 Init', board_id: 1 },
  { id: 5, title: '2 In Progress', board_id: 2 },
  { id: 6, title: '2 Done', board_id: 3 },
]

const SampleItems: Array<iKanbanItem> = [
  { id: 1, title: 'Init', board_id: 1 },
  { id: 2, title: 'In Progress', board_id: 2 },
  { id: 3, title: 'Done', board_id: 3 },
]

const SampleTreeItems: Array<iTreeItem> = [
  { id: 1, title: '1', parent_id: 0 },
  { id: 2, title: '2', parent_id: 0 },
  { id: 3, title: '3', parent_id: 0 },
  { id: 101, title: '101', parent_id: 1 },
  { id: 102, title: '102', parent_id: 1 },
  { id: 201, title: '201', parent_id: 2 },
  { id: 202, title: '202', parent_id: 2 },
  { id: 10101, title: '10101', parent_id: 101 },
  { id: 10201, title: '10201', parent_id: 102 },
];

function App() {
  // const sensors = useDefaultSensors();

  return (
    <Paper sx={{ m: 4 }}>
      <Sortable items={SampleItems} />
      <Kanban items={SampleKanbanItems} boards={SampleBoards} />
      <Tree items={SampleTreeItems} />
    </Paper>
  );
}

export default App;
